import { render, staticRenderFns } from "./NewInspirationComponent.vue?vue&type=template&id=12557be4"
import script from "./NewInspirationComponent.vue?vue&type=script&lang=js"
export * from "./NewInspirationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports